import {
  formatPriceUpliftYesNo,
  formatRenewalDeadlineDate,
  formatRenewalsAllowed,
  formatUpliftPercent,
  getContractEndIso,
  resolveRenewalPricingTerms,
} from '../../utils/renewalDetailsFormat'
import { DetailInfo, DetailRow } from '../DetailRow/DetailRow'
import { PrivateOffer } from '../../../modules/privateOffer/types'
import { useTimeZone } from '../../utils/hooks/useTimeZone'

export const RenewalDetailsView = ({
  privateOffer,
}: {
  privateOffer: PrivateOffer
}) => {
  const { timeZone } = useTimeZone()
  const endIso = getContractEndIso(privateOffer)
  const isRange =
    resolveRenewalPricingTerms(privateOffer) === 'PRICE_UPLIFT' &&
    (privateOffer.priceUpliftType ?? 'FIXED') === 'RANGE'

  return (
    <div data-testid="renewal-details-section">
      <DetailRow
        borderBottom
        children={
          <>
            <DetailInfo
              title="Number of renewals allowed"
              keyName="renewalsAllowed"
              value={formatRenewalsAllowed(privateOffer)}
            />
            <DetailInfo
              title="Opt out deadline date"
              keyName="optOutDeadlineDate"
              value={formatRenewalDeadlineDate(
                privateOffer.optOutDeadlineDays,
                endIso,
                timeZone
              )}
            />
          </>
        }
      />
      <DetailRow
        borderBottom={isRange}
        children={
          <>
            <DetailInfo
              title="Price uplift"
              keyName="priceUplift"
              value={formatPriceUpliftYesNo(privateOffer)}
            />
            <DetailInfo
              title="Price uplift %"
              keyName="priceUpliftPercent"
              value={formatUpliftPercent(privateOffer)}
            />
          </>
        }
      />
      {isRange && (
        <DetailRow
          borderBottom={false}
          children={
            <>
              <DetailInfo
                title="Max adjustment date"
                keyName="adjustmentDeadline"
                value={formatRenewalDeadlineDate(
                  privateOffer.adjustmentDeadlineDays,
                  endIso,
                  timeZone
                )}
              />
              <DetailInfo
                title="Default uplift percentage"
                keyName="defaultUpliftPercent"
                value={
                  privateOffer.defaultUpliftPercent != null
                    ? `${privateOffer.defaultUpliftPercent}%`
                    : '-'
                }
              />
            </>
          }
        />
      )}
    </div>
  )
}
